<template>
    <div>
        <package-form 
            :is-package-form-sidebar-active.sync="isPackageFormSidebarActive"
            :package-data="packageData"
            @refetch-data="refetchData"
        />
        <b-card no-body>
            <div class="m-2">
                <b-row>
                    <b-col
                        cols="12"
                        md="6"
                        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                    >
                    </b-col>
                    <b-col
                        cols="12"
                        md="6"
                    >
                        <div class="d-flex align-items-center justify-content-end">
                            <b-form-input
                                v-model="searchQuery"
                                class="d-inline-block mr-1"
                                placeholder="Search..."
                            /> 
                            <b-button
                                variant="primary"
                                @click="updatePackage()"
                            >
                                <span class="text-nowrap">Add Package</span>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <b-table
                v-if="!packages.length"
                :items="packages"
                responsive
                :fields="tableColumns"
                show-empty
                empty-text="No matching records found"
                class="position-relative"
            />
            <table v-else class="table table-striped">
                <thead>
                    <tr>
                    <th scope="col" v-for="(col, index) in tableColumns" :key="index">
                        {{col.label}}
                    </th>
                    </tr>
                </thead>
                <draggable v-model="packages" tag="tbody" hadle=".handle" @change="updateOrdering()">
                    <tr v-for="(item, index) in packages" :key="index">
                        <th scope="row" class="pl-2">
                            <MenuIcon icon="MenuIcon"/> 
                        </th>
                        <td class="pl-2">
                            <b-img
                            :src="getCoverImage(item.files)"
                            height="110"
                            width="170"
                            class="rounded m-0"
                            />
                        </td>
                        <td class="pl-2">
                            <span>{{ item.title[currentLocale] }}</span>
                        </td>
                        <td class="pl-2">
                            <span v-html="(item.slug[currentLocale])"></span>
                        </td>
                        <td class="pl-2">
                            <b-badge
                                pill
                                :variant="`light-${resolvePackageStatusVariant(item.is_active)}`"
                                class="text-capitalize"
                            >
                                {{ resolvePackageStatusnameVariant(item.is_active) }} 
                            </b-badge>
                        </td>
                        <td class="pl-2">
                            <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'"  @click="updatePackage(item)" variant="outline-success">Edit</b-button>
                            <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="ml-1" @click="deleteconfirm(item.id)" variant="outline-danger">Delete</b-button>
                        </td>
                    </tr>
                </draggable>
            </table>
            <div class="mx-2 mb-2">
                <b-row>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                        <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                    </b-col>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalPackages"
                            :per-page="perPage"
                            first-number
                            last-number
                            class="mb-0 mt-1 mt-sm-0"
                            prev-class="prev-item"
                            next-class="next-item"
                        >
                            <template #prev-text>
                                <feather-icon
                                    icon="ChevronLeftIcon"
                                    size="18"
                                />
                                </template>
                                <template #next-text>
                                <feather-icon
                                    icon="ChevronRightIcon"
                                    size="18"
                                />
                            </template>
                        </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>

<script>
    import {
        BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,BImg,
        BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup, BFormCheckbox, BImgLazy,
        BFormRating,
    } from 'bootstrap-vue'
    import Ripple from 'vue-ripple-directive'
    import vSelect from 'vue-select'
    import draggable from 'vuedraggable'
    import store from '@/store'
    import { ref,onUnmounted } from '@vue/composition-api'
    import usePackageList from './usePackageList'
    import PackageForm from '../package-form/PackageForm.vue'
    import packageStoreModule from '../packageStoreModule'
    import { MenuIcon } from 'vue-feather-icons';

    export default {
        components:{
            BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
            BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup,
            BFormCheckbox, BImg, BImgLazy, draggable, BFormRating, vSelect, BTable, PackageForm,
            MenuIcon,
        },

        directives:{
            'b-modal': VBModal,
            Ripple
        },

        computed: {
            currentLocale() {
                return  this.$i18n.locale;
            },
        },

        setup(){
            const PACKAGE_STORE_MODULE_NAME = 'app-packages'
            if (!store.hasModule(PACKAGE_STORE_MODULE_NAME)) store.registerModule(PACKAGE_STORE_MODULE_NAME, packageStoreModule)
            onUnmounted(() => {
                if (store.hasModule(PACKAGE_STORE_MODULE_NAME)) store.unregisterModule(PACKAGE_STORE_MODULE_NAME)
            });

            const getCoverImage = (files) => {
                if(files.length){
                    for(const file of files){
                        if(file.is_feature){
                            return file.path
                        }
                    }
                } else {
                    return `${require('@/assets/images/no-image.png')}`
                }
            }

            const {
                searchQuery,
                isPackageFormSidebarActive,
                packageData,
                toast,
                perPage,
                perPageOptions,
                currentPage,
                packages,
                statusFilter,
                totalPackages,
                refPackageListTable,
                contentsData,
                getLocalSite,
                tableColumns,
                dataMeta,
                refetchData,
                updatePackage,
                resolvePackageStatusVariant,
                resolvePackageStatusnameVariant,
                fetchData,
                deleteData,
                updateOrdering
            } = usePackageList()

            fetchData()

            return {
                searchQuery,
                isPackageFormSidebarActive,
                packageData,
                toast,
                perPage,
                perPageOptions,
                currentPage,
                packages,
                statusFilter,
                totalPackages,
                refPackageListTable,
                contentsData,
                getLocalSite,
                tableColumns,
                dataMeta,
                refetchData,
                updatePackage,
                resolvePackageStatusVariant,
                resolvePackageStatusnameVariant,
                getCoverImage,
                fetchData,
                deleteData,
                updateOrdering
            }
        },
        methods:{
            deleteconfirm(id){
                this.$bvModal
                    .msgBoxConfirm(`Please confirm that you want to delete Package ID = ${id}`, {
                        title: 'Please Confirm',
                        size: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Yes',
                        cancelTitle: 'No',
                        cancelVariant: 'outline-secondary',
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then(value => {
                        if(value === true){
                        this.deleteData(id)
                    }
                })
            },
        }
    }
</script>